let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3bhRA")).then(() => parcelRequire('9avSx'));